import { Filter } from 'schemas/FilterSchema'
import { SearchFilterComposingStrategy } from './searchFilterComposingStrategy'

const generateStaticStrategy = (): SearchFilterComposingStrategy => ({
  composeDetailSearchFilter: (filter: Filter) => filter
})

export default generateStaticStrategy
